// extracted by mini-css-extract-plugin
module.exports = {"toolTip":"UpgradeContainer_toolTip__P_rqE","tooltipCheckbox":"UpgradeContainer_tooltipCheckbox__hFHOE","snackBarStyle":"UpgradeContainer_snackBarStyle___8AIM"};